var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40007389_13303)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_40007389_13303)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.8046,
    cy: 37.6089,
    rx: 15.8022,
    ry: 14.141,
    transform: "rotate(-40.0287 35.8046 37.6089)",
    fill: "#7349FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_40007389_13303)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.211,
    cy: 33.4471,
    rx: 5.13537,
    ry: 14.141,
    transform: "rotate(-40.0287 36.211 33.4471)",
    fill: "#E2B1FF",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_40007389_13303)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.8504,
    cy: 42.1971,
    rx: 15.9383,
    ry: 8.03453,
    transform: "rotate(-40.0287 11.8504 42.1971)",
    fill: "#FFCB77"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_f_40007389_13303)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.16147,
    cy: 6.69357,
    rx: 16.9394,
    ry: 4.96066,
    transform: "rotate(-40.0287 8.16147 6.69357)",
    fill: "#7789FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_40007389_13303)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.8472,
    cy: 16.8415,
    rx: 8.98786,
    ry: 7.05807,
    transform: "rotate(-12.4078 14.8472 16.8415)",
    fill: "#7789FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_40007389_13303)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.3267,
    cy: 23.03,
    rx: 6.4199,
    ry: 4.70793,
    transform: "rotate(-30.3908 13.3267 23.03)",
    fill: "url(#paint0_linear_40007389_13303)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_40007389_13303)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.7459,
    cy: 20.0577,
    rx: 6.35571,
    ry: 2.55871,
    transform: "rotate(38.2703 15.7459 20.0577)",
    fill: "#FF1C1C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_40007389_13303)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.6332,
    cy: 22.5786,
    rx: 8.4728,
    ry: 10.2131,
    transform: "rotate(29.0543 23.6332 22.5786)",
    fill: "url(#paint1_linear_40007389_13303)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_40007389_13303)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.384,
    cy: 13.4289,
    rx: 8.93873,
    ry: 4.17616,
    transform: "rotate(-14.4018 19.384 13.4289)",
    fill: "url(#paint2_linear_40007389_13303)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter9_f_40007389_13303)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.70366,
    cy: 6.1813,
    rx: 14.9751,
    ry: 7.51623,
    transform: "rotate(-31.1633 5.70366 6.1813)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 18.85,
    stroke: "url(#paint3_linear_40007389_13303)",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter10_f_40007389_13303)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.9204,
    cy: 30.6347,
    rx: 10.4298,
    ry: 4.10579,
    transform: "rotate(34.7759 10.9204 30.6347)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter11_f_40007389_13303)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5695,
    cy: 37.0123,
    rx: 15.8941,
    ry: 9.25467,
    transform: "rotate(-37.4568 29.5695 37.0123)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FEFEFF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 12L20.4996 13.8554C21.2409 16.6086 23.3914 18.7591 26.1446 19.5004L28 20L26.1446 20.4996C23.3914 21.2409 21.2409 23.3914 20.4996 26.1446L20 28L19.5004 26.1446C18.7591 23.3914 16.6086 21.2409 13.8554 20.4996L12 20L13.8554 19.5004C16.6086 18.7591 18.7591 16.6086 19.5004 13.8554L20 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12L20.4996 13.8554C21.2409 16.6086 23.3914 18.7591 26.1446 19.5004L28 20L26.1446 20.4996C23.3914 21.2409 21.2409 23.3914 20.4996 26.1446L20 28L19.5004 26.1446C18.7591 23.3914 16.6086 21.2409 13.8554 20.4996L12 20L13.8554 19.5004C16.6086 18.7591 18.7591 16.6086 19.5004 13.8554L20 12Z",
    fill: "url(#paint4_linear_40007389_13303)",
    fillOpacity: 0.6
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_40007389_13303",
    x: -9.33301,
    y: -7.24188,
    width: 90.2754,
    height: 89.7016,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_40007389_13303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_40007389_13303",
    x: -3.7002,
    y: -7.87656,
    width: 79.8223,
    height: 82.6473,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_40007389_13303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_40007389_13303",
    x: -41.4062,
    y: -9.76013,
    width: 106.514,
    height: 103.915,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_40007389_13303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_40007389_13303",
    x: -45.1992,
    y: -44.8477,
    width: 106.722,
    height: 103.083,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_40007389_13303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_40007389_13303",
    x: -0.6625,
    y: 3.08103,
    width: 31.0193,
    height: 27.5209,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.3,
    result: "effect1_foregroundBlur_40007389_13303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_40007389_13303",
    x: 0.696875,
    y: 11.2298,
    width: 25.2596,
    height: 23.6004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.3,
    result: "effect1_foregroundBlur_40007389_13303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_40007389_13303",
    x: 3.90879,
    y: 9.0373,
    width: 23.6736,
    height: 22.0409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.3,
    result: "effect1_foregroundBlur_40007389_13303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_40007389_13303",
    x: 8.11875,
    y: 6.14582,
    width: 31.0291,
    height: 32.8657,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.3,
    result: "effect1_foregroundBlur_40007389_13303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_40007389_13303",
    x: 4.06309,
    y: 2.21244,
    width: 30.6414,
    height: 22.433,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.3,
    result: "effect1_foregroundBlur_40007389_13303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_40007389_13303",
    x: -13.6914,
    y: -9.88959,
    width: 38.79,
    height: 32.1418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_40007389_13303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_40007389_13303",
    x: -3.96289,
    y: 17.7953,
    width: 29.7666,
    height: 25.6789,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_40007389_13303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_40007389_13303",
    x: 9.75098,
    y: 18.8705,
    width: 39.6377,
    height: 36.2835,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_40007389_13303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40007389_13303",
    x1: 5.96384,
    y1: 25.0531,
    x2: 15.0713,
    y2: 19.0103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4902"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_40007389_13303",
    x1: 32.106,
    y1: 22.1037,
    x2: 19.3207,
    y2: 23.0453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8615FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500D99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_40007389_13303",
    x1: 19.384,
    y1: 9.25279,
    x2: 19.384,
    y2: 17.6051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF47FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB10E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_40007389_13303",
    x1: 10.6091,
    y1: 2.67647,
    x2: 32.5484,
    y2: 40.6765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#792ED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7E33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_40007389_13303",
    x1: 19.3333,
    y1: 21.3333,
    x2: 25.3333,
    y2: 15.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1E7FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E7FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40007389_13303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHi);
export default __webpack_public_path__ + "static/media/hi.d346461c5b86b560821bf3249d7ccadf.svg";
export { ForwardRef as ReactComponent };